"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    name: "ungegn_1987",
    description: "UNGEGN 1987 V/18 transliteration schema",
    url: "https://dangry.ru/iuliia/ungegn-1987/",
    mapping: {
        а: "a",
        б: "b",
        в: "v",
        г: "g",
        д: "d",
        е: "e",
        ё: "ё",
        ж: "ž",
        з: "z",
        и: "i",
        й: "j",
        к: "k",
        л: "l",
        м: "m",
        н: "n",
        о: "o",
        п: "p",
        р: "r",
        с: "s",
        т: "t",
        у: "u",
        ф: "f",
        х: "h",
        ц: "c",
        ч: "č",
        ш: "š",
        щ: "šč",
        ъ: "ʺ",
        ы: "y",
        ь: "ʹ",
        э: "è",
        ю: "ju",
        я: "ja",
    },
    prev_mapping: null,
    next_mapping: null,
    ending_mapping: null,
    samples: [
        [
            "Юлия, съешь ещё этих мягких французских булок из Йошкар-Олы, да выпей алтайского чаю",
            "Julija, sʺešʹ eščё ètih mjagkih francuzskih bulok iz Joškar-Oly, da vypej altajskogo čaju",
        ],
        [
            "Россия, город Йошкар-Ола, улица Яна Крастыня",
            "Rossija, gorod Joškar-Ola, ulica Jana Krastynja",
        ],
    ],
};
